import React from "react";
import { Mail } from "lucide-react";

export const EmailCard = ({ email, variables, onChange }) => (
  <div className="bg-white border border-brand-soft rounded-2xl p-3 space-y-2" data-testid="tpl-email-card">
    <p className="text-sm font-medium text-brand-greenDeep flex items-center gap-2"><Mail className="w-4 h-4" /> Message d'accompagnement (e-mail)</p>
    <input value={email.subject || ""} onChange={(e) => onChange({ ...email, subject: e.target.value })} placeholder="Objet" className="input w-full text-sm" data-testid="tpl-email-subject" />
    <textarea value={email.body || ""} onChange={(e) => onChange({ ...email, body: e.target.value })} rows={5} className="input w-full text-sm leading-relaxed" data-testid="tpl-email-body" />
    <div className="flex flex-wrap gap-1.5">
      <span className="text-[11px] text-brand-green/40">Insérer :</span>
      {Object.keys(variables).map((v) => (
        <button key={v} type="button" title={variables[v]} onClick={() => onChange({ ...email, body: `${email.body || ""}{${v}}` })} className="px-2 py-0.5 rounded-full bg-brand-softer text-[11px] text-brand-greenDeep hover:bg-brand-lime/40" data-testid={`tpl-email-var-${v}`}>{v}</button>
      ))}
    </div>
  </div>
);
